import { render, staticRenderFns } from "./oauth-email.vue?vue&type=template&id=5e52d19f&scoped=true&"
import script from "./oauth-email.vue?vue&type=script&lang=js&"
export * from "./oauth-email.vue?vue&type=script&lang=js&"
import style0 from "./oauth-email.vue?vue&type=style&index=0&id=5e52d19f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e52d19f",
  null
  
)

export default component.exports